import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.12 }) => {
  const reduce = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={`${i}-${line}`} className="block overflow-hidden pb-[0.32em] -mb-[0.32em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduce ? { opacity: 0 } : { y: "115%" }}
            animate={reduce ? { opacity: 1 } : { y: 0 }}
            transition={{ duration: reduce ? 0.3 : 0.95, ease: EASE, delay: reduce ? 0 : delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const FadeUp = ({ children, className = "", delay = 0, y = 40 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={{ y: reduce ? 0 : y, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: reduce ? 0.3 : 0.75, ease: EASE, delay: reduce ? 0 : delay }}
    >
      {children}
    </motion.div>
  );
};

export const Fade = ({ children, className = "", delay = 0 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: reduce ? 0.3 : 1, ease: "easeOut", delay: reduce ? 0 : delay }}
    >
      {children}
    </motion.div>
  );
};
